import { useConfig } from '@inboundx/shared/config';
import { useEffect } from 'react';
import type { SupportedLanguage } from './LanguagePicker';

const SYNC_LANGUAGES: SupportedLanguage[] = ['en', 'fr', 'es', 'de', 'it'];

/**
 * Syncs the language picker to the domain's default_language from unified config.
 * Only syncs real language codes — LLM response mode is controlled by the force setting.
 * Must be rendered inside ConfigProvider.
 */
export function LanguageSyncFromConfig({
    onLanguageDetected,
}: {
    onLanguageDetected: (lang: SupportedLanguage) => void;
}) {
    const { resolver } = useConfig();
    const defaultLanguage = resolver?.identity?.default_language;

    useEffect(() => {
        if (defaultLanguage && SYNC_LANGUAGES.includes(defaultLanguage as SupportedLanguage)) {
            onLanguageDetected(defaultLanguage as SupportedLanguage);
        }
    }, [defaultLanguage, onLanguageDetected]);

    return null;
}
